import { createTheme } from "@mui/material";
declare module "@mui/material/styles/createPalette" {

  interface CommonColors {
    oldBylawColor: string;
    oldBylawHoverColor: string;
    newBylawColor: string;
    newBylawHoverColor: string;
    oddOutputCard: string,
    evenOtputCard: string;
    darkBlue: string;
    darkBlueHover: string;
    warnLightBlue: string;
    warmGreen: string;
    acceptGreen: string;
    acceptGreenHover: string;
    bugRed: string;
    bugRedHover: string;
    disableGrey: string;
    labelGrey: string;
    white: string;
    black: string;
  }
}

const theme = createTheme({
  typography:{
    fontFamily: 'Oswald'
  },
  
  palette: {
    common: {
      oldBylawColor: '#C7C8CC',
      oldBylawHoverColor: '#B4B4B8',
      oddOutputCard: '#f7f9ff',
      evenOtputCard: '#9b9ca0',
      newBylawColor: '#eaeaff',
      newBylawHoverColor: '#dadafe',
      darkBlue: '#000028',
      darkBlueHover: '#16163c',
      warnLightBlue: '#3498db',
      warmGreen: '#059862',
      acceptGreen: '#04AA6D',
      acceptGreenHover: '#33B988',
      disableGrey: '#808080',
      labelGrey: '#E5E5E9',
      bugRed: '#7D0A0A',
      bugRedHover: '#A61D1D',
      white: '#FFF',
      black: '#000'
    },
  },
});
export default theme;